import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Import font URLs so webpack builds them into the bundle AND we can preload
// them in the document head before React mounts. Kills the FOUT (flash of
// fallback font swapping into PP Formula).
import ppRegular from "@/assets/fonts/PPFormula-CondensedRegular.ttf";
import ppItalic from "@/assets/fonts/PPFormula-CondensedRegularItalic.ttf";
import ppBlack from "@/assets/fonts/PPFormula-CondensedBlack.ttf";

[ppRegular, ppItalic, ppBlack].forEach((href) => {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "font";
  link.type = "font/ttf";
  link.crossOrigin = "anonymous";
  link.href = href;
  document.head.appendChild(link);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the service worker (only in production builds to avoid HMR conflicts)
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* noop */ });
  });
}
